import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolsService } from '../../sb-editor-tools/services/tools.service';
import { SblibService } from '../../services/sblib.service';
import { TitlesComponent } from '../../sb-editor-tools/titles/titles.component';
import { ToastrService } from 'ngx-toastr';
import { ColorInterface, Externalbtn, Favicon, Logo, Titles } from '@3ddv/ngx-sites-builder-lib';
import { ExternalbtnComponent } from '../../sb-editor-tools/externalbtn/externalbtn.component';
import { TopbarComponent } from '../../sb-editor-tools/topbar/topbar.component';
import { LogofaviconComponent } from './logofavicon/logofavicon.component';
import { Logofavicon } from './logofavicon/models/logofavicon.model';
interface Topbar {
  background: string;
  text: string;
  label: string;
  value: string;
}
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  private toolgroup: {
    titles: Titles;
    logo: Logo;
    favicon: Favicon;
    externalbtn: Externalbtn;
    topbar: Topbar;
  };
  public tabs = {
    active: 'titles',
  };

  @ViewChild('titles', { static: false }) titlesComponent: TitlesComponent;
  @ViewChild('logofavicon', { static: false }) logofaviconComponent: LogofaviconComponent;
  @ViewChild('externalbtn', { static: false }) externalbtnComponent: ExternalbtnComponent;
  @ViewChild('topbar', { static: false }) topbarComponent: TopbarComponent;

  constructor(
    private sblibService: SblibService,
    private toolsService: ToolsService,
    private toastrService: ToastrService
  ) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      this.toolgroup = {
        titles: Object.assign({}, res.titles),
        logo: Object.assign({}, res.logo),
        favicon: Object.assign({}, res.favicon),
        externalbtn: Object.assign({}, res.externalbtn),
        topbar: Object.assign({}, res.color.manual.topbar),
      };
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public save() {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (this.tabs.active === 'titles') {
        const titlescolors = Object.assign({}, this.titlesComponent.getTool());
        res.titles = titlescolors.tool;
        res.color.manual.header = titlescolors.color;
      }

      if (this.tabs.active === 'logofavicon') {
        const logoFavicon = Object.assign({}, this.logofaviconComponent.getTool());
        res.logo = logoFavicon.logo;
        res.favicon = logoFavicon.favicon;
      }

      if (this.tabs.active === 'externalbtn') {
        const externalbtn = Object.assign({}, this.externalbtnComponent.getTool());
        res.externalbtn = externalbtn.tool;
        res.color.manual.externalbtn = externalbtn.colors;
      }

      if (this.tabs.active === 'topbar') {
        res.color.manual.topbar = Object.assign({}, this.topbarComponent.getTool());
      }

      this.sblibService.apply(res);
      this.toastrService.success('', 'Changes applied');
    });
    this.subscriptions.push(tools$);
  }

  public getTool(tool: Logofavicon | Titles | Externalbtn | Topbar, toolkey: string) {
    tool = Object.assign({}, tool);
    this.toolgroup[toolkey] = tool;
  }
}
